import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { HonoraryFlag, type HonoraryFlagValue } from '@paladin-monorepo/common';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import expertsIcon from '@/assets/dashboard/experts.svg';

type HonoraryFlagBadgeProps = {
  honoraryFlag?: HonoraryFlagValue | null;
  className?: string;
  icon?: 'star' | 'experts';
};

export function HonoraryFlagBadge({
  honoraryFlag,
  className,
  icon = 'star',
}: HonoraryFlagBadgeProps) {
  const { t } = useTranslation();
  if (honoraryFlag !== HonoraryFlag.FoundingDesignPartner) {
    return null;
  }
  return (
    <Badge
      variant="primaryLight"
      className={cn(
        'max-w-full gap-2 rounded-full px-3 py-1.5 font-label font-normal uppercase hover:bg-primary-light',
        className,
      )}
    >
      {icon === 'experts' ? (
        <span className="relative size-[15px] shrink-0 overflow-clip">
          <img src={expertsIcon} alt="" className="size-full" width={15} height={15} />
        </span>
      ) : (
        <Star className="size-3.5 shrink-0" aria-hidden />
      )}
      <span className="truncate cursor-default select-none dark:text-white">
        {t('account.honorary.foundingDesignPartner')}
      </span>
    </Badge>
  );
}
